function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-2",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  opacity: 0.7
}, React.createElement("g", {
  id: "doc",
  transform: "translate(-1.000000, 0.000000)"
}, React.createElement("g", {
  id: "noun_doc_801798",
  transform: "translate(1.000000, 0.000000)",
  fill: "#636363",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "Group"
}, React.createElement("g", {
  id: "a-link"
}, React.createElement("g", {
  id: "a"
}, React.createElement("path", {
  d: "M13.7894737,15.8947368 L13.7894737,0.105263158 L0.105263158,0.105263158 L0.105263158,15.8947368 L13.7894737,15.8947368 L13.7894737,15.8947368 Z M12.7368421,14.8421053 L1.15789474,14.8421053 L1.15789474,1.15789474 L12.7368421,1.15789474 L12.7368421,14.8421053 L12.7368421,14.8421053 Z M2.21052632,8.52631579 L2.21052632,9.57894737 L11.6842105,9.57894737 L11.6842105,8.52631579 L2.21052632,8.52631579 L2.21052632,8.52631579 Z M2.21052632,12.7368421 L2.21052632,13.7894737 L11.6842105,13.7894737 L11.6842105,12.7368421 L2.21052632,12.7368421 L2.21052632,12.7368421 Z M2.21052632,10.6315789 L2.21052632,11.6842105 L11.6842105,11.6842105 L11.6842105,10.6315789 L2.21052632,10.6315789 L2.21052632,10.6315789 Z M5.36842105,5.36842105 L5.36842105,2.21052632 L2.21052632,2.21052632 L2.21052632,5.36842105 L5.36842105,5.36842105 L5.36842105,5.36842105 Z M3.26315789,4.31578947 L3.26315789,3.26315789 L4.31578947,3.26315789 L4.31578947,4.31578947 L3.26315789,4.31578947 L3.26315789,4.31578947 Z M6.42105263,2.21052632 L6.42105263,3.26315789 L11.6842105,3.26315789 L11.6842105,2.21052632 L6.42105263,2.21052632 L6.42105263,2.21052632 Z M11.6842105,7.47368421 L11.6842105,6.42105263 L2.21052632,6.42105263 L2.21052632,7.47368421 L11.6842105,7.47368421 L11.6842105,7.47368421 Z M6.42105263,4.31578947 L6.42105263,5.36842105 L11.6842105,5.36842105 L11.6842105,4.31578947 L6.42105263,4.31578947 Z",
  id: "Shape"
}))))), React.createElement("rect", {
  id: "Rectangle",
  fill: "#D8D8D8",
  opacity: 0,
  x: 0,
  y: 0,
  width: 16,
  height: 16
})));

var SvgDoc = function SvgDoc(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "14px",
    height: "16px",
    viewBox: "0 0 14 16",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDoc, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/doc.1e32ff4f.svg";
export { ForwardRef as ReactComponent };